import { useCallback, useMemo, useState } from 'react';

import { describe } from '../../dates';
import { useLanguage } from '../../contexts/language';
import { useOpenAssignment } from '../../hooks/open-assignment';

import styles from './style.module.css';

// One open questionnaire on Today: a lilac tile for a draft (only the patient
// sees it), a grey one when not started; its state, answers so far and due
// date; and Continue or Start. The whole row is the button.
export function QuestionnaireRow({ assignment }) {
  const { text, language, translate } = useLanguage();
  const openAssignment = useOpenAssignment();
  const [ busy, setBusy ] = useState(false);
  const [ error, setError ] = useState();
  const { dueDate, questionnaire, draft } = assignment;

  const onClick = useCallback(function() {
    setBusy(true);

    return openAssignment(assignment).catch(function(failed) {
      setBusy(false);
      setError(failed.message);
    });
  }, [ assignment, openAssignment ]);

  const details = [ text.notStarted ];
  let tile = `${ styles.tile } ${ styles.new }`;
  let action = text.start;

  if (draft != null) {
    details[ 0 ] = text.draftDetail.replace('{answered}', draft.answers.length).replace('{total}', questionnaire.items.length);
    tile = `${ styles.tile } ${ styles.draft }`;
    action = text.continue;
  }

  if (dueDate != null) {
    details.push(text.dueLower.replace('{date}', describe({ day: dueDate, language, short: true })));
  }

  const message = useMemo(function() {
    if (error == null) {
      return null;
    }

    return <span className={ styles.error } role='alert'>{ translate(error) }</span>;
  }, [ error, translate ]);

  return (
    <>
      <button className={ styles.row } type='button' disabled={ busy } onClick={ onClick }>
        <span className={ tile } aria-hidden='true'><span className={ styles.icon }></span></span>

        <span className={ styles.lines }>
          <span className={ styles.name }>{ questionnaire.name }</span>
          <span className={ styles.details }>{ details.join(' · ') }</span>
        </span>

        <span className={ styles.action }>{ action }</span>
      </button>

      { message }
    </>
  );
}
